<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-link :to="{ name: 'Merchants-list' }">
            <feather-icon icon="ArrowLeftIcon" />
            <span class="align-middle ml-50">Back to List</span>
          </b-link>
        </b-col>
      </b-row>

      <b-card-header>
        <h3>
          Details Merchant :<strong>{{ this.$route.params.name }}</strong>
        </h3>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col md="5">
            <b-form-group>
              <strong>Name</strong>:
              <span>{{ detailMerchantFormData.name }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Channel: </strong>
              <span>{{ detailMerchantFormData.channel }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Company: </strong>
              <span>{{ detailMerchantFormData.companyName }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Max Days Refund Is Allowed: </strong>
              <span>{{
                detailMerchantFormData.noOfMaxDaysRefundIsAllowed
              }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Merchant Identifier: </strong>
              <span>{{ detailMerchantFormData.merchantIdentifier }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Account Group: </strong>
              <span>{{
                accountGroupEnum.filter(
                  (f) => f.value == detailMerchantFormData.accountGroup
                )[0].text
              }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Authorization ShortCode: </strong>
              <span>{{ detailMerchantFormData.authorizationShortCode }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Default Expiry Hour: </strong>
              <span>{{ detailMerchantFormData.defaultExpiryHour }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Refund Capping Limit: </strong>
              <span>{{ detailMerchantFormData.refundCappingLimit }}</span>
            </b-form-group>

            <b-form-group>
              <strong>Bank Short Code: </strong>
              <span>{{ detailMerchantFormData.bankShortCode }}</span>
            </b-form-group>
            <b-form-group>
              <strong>CBE Short Code: </strong>
              <span>{{ detailMerchantFormData.cbeBirrShortCode }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Tele Birr Code: </strong>
              <span>{{ detailMerchantFormData.teleBirrShortCode }}</span>
            </b-form-group>

            <b-form-group>
              <strong>Refund Confirmation Email: </strong>
              <span>{{ detailMerchantFormData.refundConfirmationEmail }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Refund Access Type: </strong>
              <span>{{ detailMerchantFormData.refundAccessType }}</span>
            </b-form-group>

            <b-form-group>
              <strong>Confirm Retry Required: </strong>
              <span>{{ detailMerchantFormData.confirmRetryRequired }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Merchant Need Own OrderCode: </strong>
              <span>{{ detailMerchantFormData.merchantNeedOwnOrderCode }}</span>
            </b-form-group>
          </b-col>
          <b-col md="7">
            <b-form-group>
              <strong>Refund Confirmation NotifyURL: </strong>
              <span>{{
                detailMerchantFormData.refundConfirmationNotifyURL
              }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Approve URI: </strong>
              <span>{{ detailMerchantFormData.approvedURI }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Return URI: </strong>
              <span>{{ detailMerchantFormData.returnURI }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Pending URI: </strong>
              <span>{{ detailMerchantFormData.pendingURI }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Declined URI: </strong>
              <span>{{ detailMerchantFormData.declinedURI }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Cancel URI: </strong>
              <span>{{ detailMerchantFormData.cancelURI }}</span>
            </b-form-group>
            <b-form-group>
              <strong
                >Send Email When User Assigned For Refund WorkFlow:
              </strong>
              <span>{{
                detailMerchantFormData.sendEmailWhenUserAssignedForRefundWorkFlow
              }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Refund To Separate Account: </strong>
              <span>{{ detailMerchantFormData.refundToSeparateAccount }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Refund Action WorkFlow Required MinimumAmount: </strong>
              <span>{{
                detailMerchantFormData.refundActionWorkFlowRequiredMinimumAmount
              }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Refund Action WorkFlow Required: </strong>
              <span>{{
                detailMerchantFormData.refundActionWorkFlowRequired
              }}</span>
            </b-form-group>

            <b-form-group>
              <strong>Is Reconcilation Needed: </strong>
              <span>{{ detailMerchantFormData.isReconcilationNeeded }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Confirm Retry Required: </strong>
              <span>{{ detailMerchantFormData.confirmRetryRequired }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Confirm Retrial Attempt Allowed Count: </strong>
              <span>{{
                detailMerchantFormData.confirmRetrialAttemptAllowedCount
              }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <app-collapse accordion>
          <app-collapse-item
            title="Refund Workflow configuration"
            :is-visible="true"
          >
            <div>
              <div>
                <b-row
                  v-for="item in items"
                  :id="item.id"
                  :key="item.id"
                  ref="row"
                >
                  <b-col md="4">
                    <b-form-group label="Level" label-for="item-name">
                      <span>{{ item.level }}</span>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group label="Assigned User Email" label-for="email">
                      <!-- <span>{{ item.userId.text }}</span> -->
                    </b-form-group>
                  </b-col>

                  <b-col lg="2" md="3" class="mb-50" />
                  <b-col cols="12">
                    <hr />
                  </b-col>
                </b-row>
              </div>
            </div>
          </app-collapse-item>
        </app-collapse>
      </b-card-body>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BCardBody,
  BCardHeader,
  BOverlay,
  BLink,
} from "bootstrap-vue";

import { required } from "@validations";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    AppCollapse,
    AppCollapseItem,
    BCardBody,
    BCardHeader,
    BOverlay,
    BLink,
  },
  data() {
    return {
      isLoading: false,
      required,
      detailMerchantFormData: {},
      accountGroupEnum: [
        { value: 1, text: "Revenue Ticket" },
        { value: 2, text: "E-Staff Ticket" },
        { value: 3, text: "Aviation University" },
        { value: 4, text: "Ethiopian Visa" },
        { value: 5, text: "Ethiopian Passport" },
        { value: 6, text: "Ethiopian OriginID" },
        { value: 7, text: "Ethiopian Cargo" },
      ],
      companyIdOptions: [],
      refundAccessTypeOptions: [
        { value: 1, text: "Gatway" },
        { value: 2, text: "Merchant" },
      ],
      selectedMerchantName: "",
      items: [
        {
          level: 1,
          userId: null,
          id: 0,
        },
      ],
      nextTodoId: 1,
      users: [],
      selelctedLevels: [],
      allUsers: [],
    };
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
    this.fetchData();
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    repeateAgain() {
      this.nextTodoId += 1;
      this.items.push({
        level: this.nextTodoId,
        userId: null,
        id: 0,
      });
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.nextTodoId -= 1;
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Merchants-View");

      axios
        .get(`/Merchant/api/V1.0/Merchants/GetById?id=${this.$route.params.id}`)
        .then((res) => {
          this.detailMerchantFormData = res.merchant;
          console.log(this.detailMerchantFormData);
          if (res.merchant.refundWorkFlow.length > 0) {
            this.items = [];
            res.merchant.refundWorkFlow.forEach((item) => {
              const usersAll = this.users;
              const selectedItem = usersAll.filter(
                (f) => f.value === item.userId
              )[0];
              this.items.push({
                id: item.id,
                level: item.level,
                userId: {
                  value: selectedItem.value,
                  text: selectedItem.text,
                },
              });
              this.nextTodoId = item.level;
            });
          }
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped></style>
